import { Search as SearchIcon } from '@mui/icons-material'
import { Box, InputAdornment, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useIsThemeV2 } from '@omnea-app/omui/NewThemeProvider'

interface SettingsSearchbarProps {
  searchQuery: string
  onSearchChange: (value: string) => void
}

export const SettingsSearchbar = ({ searchQuery, onSearchChange }: SettingsSearchbarProps) => {
  const { t } = useTranslation('settings')
  const isThemeV2 = useIsThemeV2()

  return (
    <Box sx={{ p: 3 }}>
      <TextField
        fullWidth
        placeholder={t('search-placeholder')}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: isThemeV2 ? undefined : 'neutralLight.900', width: 18, height: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={
          isThemeV2
            ? undefined
            : (theme) => ({
                '& .MuiOutlinedInput-root': {
                  height: '32px',
                  backgroundColor: 'transparent',
                  '& fieldset': {
                    borderColor: theme.palette.divider,
                    borderWidth: '1px',
                    borderRadius: 2.5,
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.text.disabled,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.text.disabled,
                  },
                  paddingLeft: '12px',
                },
                '& .MuiInputBase-input': {
                  padding: '5.5px 10px 5.5px 0',
                  fontSize: 12,
                  color: theme.palette.text.secondary,
                  height: '32px',
                },
                '& .MuiInputBase-input::placeholder': {
                  color: theme.palette.text.disabled,
                  opacity: 1,
                  fontSize: 12,
                },
              })
        }
      />
    </Box>
  )
}
